/**
 * 客户端列表
 */
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// import update from 'immutability-helper';
import { forEach, map } from 'lodash';
import moment from 'moment';
import { List, Icon, DatePicker, Button, Popover, Modal, Input } from 'antd';
import Select from 'react-select';

import 'antd/dist/antd.css';
import { Card, CardBlock, Row, Col } from 'reactstrap';
import { SERVER_URL } from './../../../config/host';

import * as actionCreators from './../../../actions/qrimages';
import * as actionCustomer from './../../../actions/customer';

@connect(
  state => ({
    qrimages: state.get('QRImages'),
    customerState: state.get('Customer')
  }),
  dispatch => ({
    qrimagesAction: bindActionCreators(actionCreators, dispatch),
    customerAction: bindActionCreators(actionCustomer, dispatch)
  })
)
export default class QRImage extends Component {
  constructor(props, ctx) {
    super(props, ctx);
    this.state = {
      limit: 5,
      current: 1,
      status: 'checking',
      icon: '',
      customer: '',
      date: '',
      large: false,
      visible: false,
      path: '',
      remark: '',
      loading: false
    }
  }
  componentWillMount() {
    const { qrimagesAction, customerAction } = this.props;
    qrimagesAction.fetchQRImages({ limit: this.state.limit, status: this.state.status, page: this.state.current });
    customerAction.fetchCustomerNameList({});
  }
  // props 改变时调用
  componentWillReceiveProps(nextProps) {
    const { customerState, qrimages } = nextProps;
    const { data } = (customerState && customerState.toJS().data) || {};
    const exportData = (qrimages && qrimages.toJS().export.data) || {};
    this.setState({ customerName: data, exportData: exportData });
  }
  onKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.search();
    }
  }
  // 设置经销商
  setCustomer = (value) => {
    this.setState({
      customer: (value && value.id) || ''
    })
  }
  // 设置状态
  setStatus = (value) => {
    this.setState({
      status: (value && value.id) || ''
    })
  }
  // 设置时间
  setDate = (value) => {
    let date;
    if (value) {
      date = moment(value).format('YYYYMMDD');
    }
    this.setState({
      date: date || ''
    })
  }
  search = () => {
    this.setState({
      icon: this.state.status
    })
    this.pageChange(this.state.current);
  }
  // 弹窗控制
  handleOk = () => {
    this.setState({
      loaded: !this.state.loaded
    });
  }
  handleCancel = () => {
    this.setState({
      loaded: !this.state.loaded
    });
  }
  export = () => {
    const { qrimagesAction, qrimages } = this.props;
    this.setState({ loading: true });
    const { date, status, customerId, qrcode } = this.state;
    qrimagesAction.fetchGetQRImageExport({ date: date, status: status, customerId: customerId, qrcode: qrcode })
      .then(() => {
        const loaded = qrimages && qrimages.get('loaded');
        this.setState({ loaded: loaded, loading: false });
      })
  }
  typein = field => (e) => {
    this.setState({ [field]: e.target.value });
  }
  submit = (value) => {
    const { qrimagesAction } = this.props;
    if (value.status === 'checkPass') {
      this.setState({ pass: true });
    }
    if (value.status === 'checkFail') {
      this.setState({ fail: true });
    }
    qrimagesAction.fetchCheckQRImage(value)
      .then(() => { this.search() })
      .catch(() => { this.search() })
  };
  image = (value) => {
    this.setState({
      visible: !this.state.visible,
      path: value
    })
  }
  useReason = (value) => {
    this.setState({ remark: value.reason });
  };
  pageChange = (page) => {
    this.setState({ current: page });
    const { qrimagesAction } = this.props;
    const { date, limit, status, customer, qrcode } = this.state;
    qrimagesAction.fetchQRImages({ limit: limit, date: date, page: page, status: status, customer: customer, qrcode: qrcode });
  }
  render() {
    const { qrimages } = this.props;
    const { data } = (qrimages && qrimages.toJS().data) || {};
    const { docs, total } = data || {};
    const { customerName, customer, status, remark, exportData } = this.state;
    const listData = [];
    const statusList = [
      { id: 'checking', value: '审核中' },
      { id: 'checkFail', value: '审核失败' },
      { id: 'checkPass', value: '审核成功' }
    ]
    forEach(docs, (row) => {
      const user = row && row.user;
      const createdDate = moment(row.createdAt).format('YYYY-MM-DD HH:MM:SS');
      listData.push({
        id: `${row.id}`,
        title: `${createdDate} / ${row.remark}`,
        filepath: `${SERVER_URL}/${row.filePath}`,
        status: map(statusList, (test) => { if (test.id === row.status) { return test.value; } }),
        customer: `${user.customer.code} / ${user.customer.name}`,
        user: `${user.name} / ${user.phone}`,
        content: `${row.qrcode} / ${row.upn} / ${row.lot}`,
      });
    })
    const pagination = {
      pageSize: this.state.limit,
      current: this.state.current,
      total: total,
      onChange: (this.pageChange),
    };
    const IconText = ({ type, text }) => (
      <span>
        <Icon type={type} style={{ marginRight: 8 }} />
        {text}
      </span>
    );
    return (
      <Card>
        <CardBlock>
          <Row className="form-group">
            <Col md="12">
              <div className="input-group">
                <Col md="2">
                  <DatePicker
                    format="YYYY-MM-DD"
                    size="large"
                    style={{ width: '100%' }}
                    placeholder="日期"
                    onChange={e => this.setDate(e)}
                  />
                </Col>
                <Col md="2">
                  <Select
                    placeholder="状态"
                    labelKey="value"
                    valueKey="id"
                    value={status || ''}
                    options={statusList}
                    onChange={e => this.setStatus(e)}
                  />
                </Col>
                <Col md="3">
                  <Select
                    placeholder="经销商"
                    labelKey="name"
                    valueKey="id"
                    value={customer || ''}
                    options={customerName}
                    onChange={e => this.setCustomer(e)}
                  />
                </Col>
                <Col md="3">
                  <Input placeholder="输入二维码" onChange={this.typein('qrcode')} />
                </Col>
                <Col md="1">
                  <span className="input-group-btn">
                    <button type="button" size="large" className="btn btn-primary btn-pointer" onClick={this.search}><i className="fa fa-search" /> </button>
                  </span>
                </Col>
                <Col md="1">
                  <span className="input-group-btn">
                    <button size="large" onClick={this.export} className="btn btn-primary btn-pointer">{this.state.visible ? '导出中' : '导出'}</button>
                  </span>
                  <Modal
                    visible={this.state.loaded}
                    title="提示"
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                  >
                    <p>导出成功,请长按地址在浏览器打开</p>
                    <p>https://bscqr.qtdatas.com/{exportData && exportData.data && exportData.data.downloadUrl}</p>
                  </Modal>
                </Col>
              </div>
            </Col>
          </Row>
          <Row className="form-group">
            <Col md="12">
              <List
                itemLayout="vertical"
                size="large"
                loading={this.state.loading}
                pagination={pagination}
                dataSource={listData}
                renderItem={item => (
                  <List.Item
                    key={item.title}
                    actions={[
                      <a onClick={() => this.submit({ qrId: item.id, status: 'checkPass', remark: '审核通过' })}><IconText type={this.state.icon === 'checkPass' ? 'like' : 'like-o'} text="通过" /></a>,
                      <Popover
                        content={(
                          <span>
                            <Row className="form-group">
                              <div className="input-group">
                                <Select
                                  style={{ width: '200px' }}
                                  placeholder="选择理由"
                                  labelKey="reason"
                                  valueKey="reason"
                                  value={remark || ''}
                                  options={[
                                    { reason: '未包含中/英文标签' },
                                    { reason: '外包装破损不明显' },
                                    { reason: '非法二维码标签' }
                                  ]}
                                  onChange={e => this.useReason(e)}
                                />
                                <Button type="primary" onClick={() => this.submit({ qrId: item.id, status: 'checkFail', remark: this.state.remark })}>确定</Button>
                              </div>
                            </Row>
                          </span>)}
                      >
                        <a><IconText type={this.state.icon === 'checkFail' ? 'dislike' : 'dislike-o'} text="不通过" /></a>
                      </Popover>
                    ]}
                    extra={
                      <a onClick={() => this.image(item.filepath)}>
                        <img width={272} height={210} alt="logo" src={item.filepath} />
                      </a>
                    }
                  >
                    <List.Item.Meta
                      title={item.title}
                      description={item.status}
                    />
                    {item.customer}<br /><br />
                    {item.user}<br /><br />
                    {item.content}
                  </List.Item>
                )}
              />
            </Col>
          </Row>
          <Modal
            width={700}
            height={500}
            visible={this.state.visible}
            footer={null}
            onOk={this.image}
            onCancel={this.image}
            bodyStyle={{ margin: '0px 0px 0px 0px', padding: '0px 0px 0px 0px' }}
          >
            <img width={700} height={500} src={this.state.path} alt="log" />
          </Modal>
        </CardBlock>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./containers/App/QRImage/index.js